import * as React from 'react';
import { getFileVariant, getLang, translate } from '@js/common/helpers';
import { CustomFileVariantsEnum } from 'tagwalk-api-client/assets/js/Types/Enums';
import { CSSTransition } from 'react-transition-group';
var lang = getLang();
var PaidReport = function (_a) {
    var _b, _c;
    var report = _a.report, cdn = _a.cdn, isNewReport = _a.isNewReport;
    var descriptionProperty = 'description' + (lang === 'en' ? '' : '_' + lang);
    var description = (_c = (_b = report[descriptionProperty]) !== null && _b !== void 0 ? _b : report['description']) !== null && _c !== void 0 ? _c : '';
    var _d = React.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    return (React.createElement(CSSTransition, { in: isOpen, timeout: 900, classNames: "opened" },
        React.createElement("div", { className: "list-item" },
            React.createElement("img", { className: "list-item-cover", src: getFileVariant(report.cover.filename, CustomFileVariantsEnum.report_banner, cdn), alt: report.name }),
            (isNewReport && !isOpen) && (React.createElement("span", { className: "new-report" }, translate('report.new', {}, 'app'))),
            React.createElement("div", { className: "list-item-details" },
                React.createElement("p", { className: "list-item-details-date" }, new Date(report.publication_date).toLocaleDateString()),
                React.createElement("h3", null, report.name),
                React.createElement("span", { onClick: function () { return setIsOpen(true); }, className: "list-item-btn" }, translate('report.know_more', {}, 'app'))),
            React.createElement("i", { onClick: function () {
                    return setIsOpen(false);
                }, className: "fal fa-2x fa-times item-close" }),
            React.createElement("div", { className: "item-information" },
                React.createElement("div", { className: "text", dangerouslySetInnerHTML: { __html: description } }),
                React.createElement("div", { className: "buttons-container" },
                    React.createElement("a", { className: "list-item-btn", href: report.preview_link }, translate('report.download_preview', {}, 'app')),
                    React.createElement("a", { className: "list-item-btn", href: report.payment_link, target: "_blank" }, translate('report.buy', {}, 'app')))))));
};
export { PaidReport };
